import { render, staticRenderFns } from "./VerifyAge.vue?vue&type=template&id=694eb282&scoped=true&"
import script from "./VerifyAge.vue?vue&type=script&lang=js&"
export * from "./VerifyAge.vue?vue&type=script&lang=js&"
import style0 from "./VerifyAge.vue?vue&type=style&index=0&id=694eb282&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694eb282",
  null
  
)

export default component.exports